import './App.css';
import React from 'react';
import Home from './Home';
import Formula from './formula';
import TimeHack from './TimeHack';
import Stocks from './Stocks';
import Crypto from './Crypto';
import StockDetail from './StockDetail';
import TagTasks from './TagTasks';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";

import Navbarmenu from './Navbarmenu';

class App extends React.Component {
  render() {
    return (
      <div>
        <Router>
          {/* <Navbarmenu /> */}
          <Switch>
            <Route exact path="/"> <Home /> </Route>
            <Route exact path="/formula"> <Formula /> </Route>
            <Route exact path="/timehack"> <TimeHack /> </Route>
            <Route exact path="/stocks"> <Stocks /> </Route>
            <Route path="/stocks/:symbol/:itemIndex?"> <StockDetail /> </Route>
            <Route exact path="/crypto"> <Crypto /> </Route>
            <Route exact path="/tags/:tag"> <TagTasks /> </Route>
          </Switch>
        </Router>
      </div>)
  }
}

export default App;
